import { createContext } from "react";

interface ConsentModeContextProps {
  hasConsentMode: boolean;
  hasFunctionalityConsentMode: boolean;
  hasAnalyticsConsentMode: boolean;
  hasMarketingConsentMode: boolean;
}

export const ConsentModeContext = createContext<ConsentModeContextProps>({
  hasConsentMode: false,
  hasFunctionalityConsentMode: false,
  hasAnalyticsConsentMode: false,
  hasMarketingConsentMode: false,
});
